export {
    getUploadCredentialsForRequest,
    getReadCredentialsForRequest,
    getUploadCredentials,
    getUploadCredentialsObservable,
} from './portal-media';
export type { UploadFileMediaCredentials } from './types';
